<template>
  <div class="body-width" >
    <div class="div-row div-pad-top news-Medium-24" >
      智能船桥
    </div>
    <div class="div-row">
      <p class="indentation">智能船桥产品包括智能电子海图显示与信息系统（ECDIS）、船舶智能避碰辅助决策系统和航海视觉增强系统等。</p>
    </div>
    <div>
      <div align="left">
        <span class="news-Medium-18">智能ECDIS</span>
        <div>
          <p class="indentation">
          自主研发、满足IEC 61174最新标准的ECDIS已获得CCS型式认可，广泛应用于航运领域。除具备海图显示、海图作业、海图改正、定位与导航、信息查询、航线设计、雷达图像叠加、航路监控、航行记录等ECDIS基础功能之外，本系统还有以下特点：
          </p>
        </div>
        <div class= "function_detail" >
          <ul>
            <li><span>极区海图显示</span></li>
            <li><span>智能航线设计及优化</span></li>
            <li><span>气象信息叠加</span></li>
            <li><span>气象定线</span></li>
            <li><span>驾驶台值班报警系统（BNWAS）</span></li>
            <li><span>中英文界面一键切换</span></li>
          </ul>
        </div>
      </div>
      <div class="function_img pad_right">
        <img src="../../../../assets/images/productcenter/zncy/zncq/1.png">
      </div>
    </div>
    <div style="padding-top: 574px">
      <div align="left">
        <span class="news-Medium-18">航海视觉增强系统</span>
        <div>
          <p class="indentation">
            系统基于增强现实、计算机视觉、船舶运动数学模型、多传感器信息融合等技术，实现智能船桥中的航海视觉增强。系统具有以下功能：
          </p>
        </div>
        <div class= "function_detail" >
          <ul>
            <li><span>多传感器数据通信与融合</span></li>
            <li><span>鲁棒的视觉惯性里程计</span></li>
            <li><span>基于船舶运动特性的助航信息生成</span></li>
            <li><span>基于计算机视觉的移动目标跟踪</span></li>
            <li><span>基于增强现实技术的助航信息呈现</span></li>
            <li><span>六自由度实时相机位姿计算</span></li>
          </ul>
        </div>
      </div>
      <div class="function_img pad_right">
        <img src="../../../../assets/images/productcenter/zncy/zncq/2.png">
      </div>
    </div>
    <div style="padding-top: 455px">
      <div align="left">
        <span class="news-Medium-18">智能避碰辅助决策系统</span>
        <div>
          <p class="indentation">
            系统基于国际海上避碰规则，实现复杂水域、复杂会遇局面条件下的船舶智能避碰。作为智能船桥的核心系统，可集成于ECDIS供实船应用。也可作为智能船舶仿真验证平台的关键模块，供第三方进行算法测试和验证。
          </p>
        </div>
        <div class= "function_detail" >
          <ul>
            <li><span>基于国际海上避碰规则，算法稳定、高效</span></li>
            <li><span>适用于狭水道、内河航道和分道通航制等水域</span></li>
            <li><span>避让目标可以是非智能船、智能船和静态碍航物</span></li>
            <li><span>动态目标实时跟踪</span></li>
            <li><span>避让参数根据需要实时调整</span></li>
            <li><span>各种吨位船舶、各种海况条件下智能避碰测试</span></li>
          </ul>
          <div  style="padding-top: 20px">
            <img src="../../../../assets/images/productcenter/zncy/zncq/3.png">
          </div>
        </div>
      </div>
      <div style="padding-right:20px">
        <div  style="padding-bottom: 20px">
          <img src="../../../../assets/images/productcenter/zncy/zncq/4.png">
        </div>
        <div>
          <img src="../../../../assets/images/productcenter/zncy/zncq/5.png">
        </div>
      </div>
      <div style="padding: 20px 200px 0px 0px">
        <img src="../../../../assets/images/productcenter/zncy/zncq/6.png">
      </div>
    </div>
  </div>
</template>

<script>
  export default {
      name: "zncq"
  }
</script>

<style scoped>
  .div-pad-top {
    padding-top: 50px;
    padding-bottom: 30px;
  }
  .function_detail{
    float: left;
  }
  .function_img{
    float: right;

  }
  .pad_right{
    padding-right:80px
  }
  p{
    font-size: 16px;
    color: #666666;
  }
  li{
    color: #2E79BE;
  }
  li span{
    color: #666666;
  }
</style>



// WEBPACK FOOTER //
// src/components/contentcoms/prodecutcontentcoms/zncyxlcp/zncq.vue